import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findGuarantee = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-work/v2/guarantee?` + params,
        method: 'GET'
    })
}
export const findProject = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-work/v2/project/select?` + params,
        method: 'GET'
    })
}

export const addGuarantee = (params) => {
    return request({
        url: `${baseUrl}/joins-work/v2/guarantee`,
        method: 'POST',
        data: params
    })
}
export const findGuaranteeDetail = (id) => {
    return request({
        url: `${baseUrl}/joins-work/v2/guarantee/${id}`,
        method: 'GET'
    })
}
export const editGuarantee = (params) => {
    return request({
        url: `${baseUrl}/joins-work/v2/guarantee`,
        method: 'PUT',
        data: params
    })
}


export const delItem = (deleteOption, ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-work/v2/guarantee/${temp}?option=${deleteOption}`,
        method: 'DELETE'
    })
}







